/* The home (design: themes/neropos/design/home-wow/v3.html). Written by dev/np-home-sync.mjs: edit it there. */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('js');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.max(a === undefined ? 0 : a, Math.min(b === undefined ? 1 : b, v)); };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var out3 = function (t) { return 1 - Math.pow(1 - t, 3); };

  /* The shop's own numbers (sections/np-home.liquid: window.NP_HOME; the discounts and free shipping are the theme
     settings, in window.NP) */
  var H = window.NP_HOME || {}, NPx = window.NP || {};
  var SCENTS = H.scents || {};
  var money = function (c) { return window.NPCart ? NPCart.money(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  /* The cart (np-cart.js: the drop flies into the bag, then the drawer) and the toast (np-pages.js) */
  function toast(msg) { if (NPx.toast) NPx.toast(msg); }
  function add(scent, n, btn) {
    var s = SCENTS[scent];
    if (!s || !s.variant || !window.NPCart) return;
    NPCart.add(s.variant, n, { title: s.name }, btn).catch(function (err) { toast(err.shown || (NPx.tx ? NPx.tx('error') : '')); });
  }

  /* Waves: one period of 141 units (the wordmark) or 480 (the page edge), repeated, so a shift by one period is seamless */
  function wave(x0, x1, P, y0, amp, bottom) {
    var d = 'M' + x0 + ' ' + y0;
    for (var x = x0; x < x1; x += P) d += ' Q' + (x + P / 4) + ' ' + (y0 - amp) + ' ' + (x + P / 2) + ' ' + y0 + ' T' + (x + P) + ' ' + y0;
    return d + ' V' + bottom + ' H' + x0 + ' Z';
  }
  $('[data-wmwave="front"]').setAttribute('d', wave(-705, 846, 141, 6, 6, 320));
  $('[data-wmwave="back"]').setAttribute('d', wave(-635, 916, 141, 2, 5, 320));
  $('[data-wave="front"]').setAttribute('d', wave(-705, 846, 141, 10, 5, 320));
  $('[data-wave="back"]').setAttribute('d', wave(-635, 916, 141, 6, 4, 320));
  $('[data-wc="front"]').setAttribute('d', wave(0, 2400, 480, 62, 16, 112));
  $('[data-wc="back"]').setAttribute('d', wave(-240, 2400, 480, 46, 14, 112));
  $('[data-bw="front"]').setAttribute('d', wave(0, 1920, 480, 24, 12, 48));
  $('[data-bw="back"]').setAttribute('d', wave(-240, 1920, 480, 18, 10, 48));
  $$('[data-fc="front"]').forEach(function (p) { p.setAttribute('d', wave(0, 2400, 480, 62, 16, 112)); });
  $$('[data-fc="back"]').forEach(function (p) { p.setAttribute('d', wave(-240, 2400, 480, 46, 14, 112)); });
  $$('[data-dw="front"]').forEach(function (p) { p.setAttribute('d', wave(0, 1920, 480, 24, 12, 48)); });
  $$('[data-dw="back"]').forEach(function (p) { p.setAttribute('d', wave(-240, 1920, 480, 18, 10, 48)); });

  /* Videos: they play on their own as loops while on screen, never with reduced motion (then their posters stay);
     nothing here ever moves their time */
  var groups = { dive: { on: !reduce }, bottle: { on: !reduce }, care: { on: !reduce }, dose: { on: !reduce }, aeg: { on: !reduce } };
  function want(v, show, g) {
    if (!v) return;
    if (show && groups[g].on) {
      if (!v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    } else if (!v.paused) v.pause();
  }
  function load(v) { if (v && !v.getAttribute('src') && v.getAttribute('data-src')) { v.src = v.getAttribute('data-src'); v.preload = 'auto'; } }

  /* 1 + 2. The film. Where the glass is in each clip, in its own pixels; ring = the left edge of its chrome ring */
  var MODES = {
    wide: { src: (H.hero || {}).wide, poster: (H.hero || {}).widePoster, w: 1920, h: 1080, cx: 1408, cy: 528, r: 418, ring: 850 },
    tall: { src: (H.hero || {}).tall, poster: (H.hero || {}).tallPoster, w: 1080, h: 1920, cx: 567, cy: 1143, r: 316 }
  };
  var dive = $('[data-dive]'), stage = $('[data-stage]'), heroWrap = $('[data-hero-wrap]'), scene = $('[data-scene]');
  var heroV = $('[data-hero-video]'), enzV = $('[data-enz-video]'), macro = $('[data-macro]'), ring = $('[data-ring]');
  var heroCopy = $('[data-hero-copy]'), enzCopy = $('[data-enz-copy]'), shade = $('[data-shade]'), cue = $('[data-cue]');
  var words = $$('.hero__brand .wm, .hero__claim, .hero__lead, .badges li');
  var tallQ = matchMedia('(max-aspect-ratio: 4/5)'), mode = '', G = null, SEND = 3, diveP = 0, diveOn = true;
  if (reduce) dive.classList.add('dive--static');
  // the bottle's scene rising over the cloth like water (paintRise): W is how far it rises, in px of scroll, both how
  // long the film's stage holds on and how far ahead the bottle's stage is pinned; s is the scroll's place against the
  // moment the film's stage lets go (the scene is whole there), Y where the crest is on the screen
  var riseEl = $('[data-rise]'), riseFoot = riseEl && riseEl.querySelector('.rise__foot'), FL = { on: !reduce && !!riseEl && getComputedStyle(riseEl).display !== 'none', W: 0, cH: 110, s: -1e9, Y: 0, shown: false, cut: '', w: '', sunk: false, ff: '' };
  function setMode() {
    var m = tallQ.matches ? 'tall' : 'wide';
    if (m === mode) return;
    mode = m; stage.classList.toggle('is-tall', m === 'tall');
    heroV.poster = MODES[m].poster; heroV.src = MODES[m].src;
    if (!reduce) { var p = heroV.play(); if (p && p.catch) p.catch(function () {}); }
  }
  function measure() {
    var W = heroWrap.clientWidth, H = heroWrap.clientHeight, M = MODES[mode];
    if (!W || !H) return;
    var s, ox, oy;
    if (mode === 'wide') {
      // the machine fills the height at the right; where the screen is narrower than the clip it slides right
      // (at most a fifth of the glass leaves the screen) so the words stay clear of its ring
      s = H / M.h; ox = W - M.w * s; oy = 0;
      var right = 0;
      words.forEach(function (el) { right = Math.max(right, el.getBoundingClientRect().right); });
      ox += clamp(right + 28 - (ox + M.ring * s), 0, .4 * M.r * s);
    } else {
      s = Math.max(W / M.w, H / M.h); ox = (W - M.w * s) / 2; oy = (H - M.h * s) / 2;
    }
    heroV.style.left = ox.toFixed(1) + 'px'; heroV.style.top = oy.toFixed(1) + 'px';
    heroV.style.width = (M.w * s).toFixed(1) + 'px'; heroV.style.height = (M.h * s).toFixed(1) + 'px';
    G = { x: ox + M.cx * s, y: oy + M.cy * s, r: M.r * s };
    // how far the glass must grow to cover the farthest corner
    var far = 0;
    [[0, 0], [W, 0], [0, H], [W, H]].forEach(function (c) { far = Math.max(far, Math.hypot(c[0] - G.x, c[1] - G.y)); });
    SEND = far / G.r * 1.04;
    scene.style.transformOrigin = G.x.toFixed(1) + 'px ' + G.y.toFixed(1) + 'px';
    enzV.style.transformOrigin = G.x.toFixed(1) + 'px ' + G.y.toFixed(1) + 'px';
  }
  function paintDive() {
    if (!G) return;
    var r = dive.getBoundingClientRect(), run = dive.offsetHeight - stage.clientHeight - FL.W;
    // once the bottle's stage has taken over from it, the film is out of sight (under the bottle) and still
    diveOn = r.bottom > 0 && r.top < innerHeight && !(FL.on && r.bottom < stage.clientHeight);
    if (reduce) {
      diveP = clamp(-r.top / Math.max(1, dive.offsetHeight - innerHeight));
      return;
    }
    var p = run > 0 ? clamp(-r.top / run) : 0; diveP = p;
    // the words leave, the camera dives into the glass, and inside the drum the laundry fades into the cloth;
    // the glass then grows past the corners and the cloth fills the screen
    var smooth = function (t) { return t * t * (3 - 2 * t); };
    var copyOut = out3(clamp((p - .01) / .14));
    var zoom = smooth(clamp((p - .04) / .66));
    var S = 1 + (SEND - 1) * zoom, rad = G.r * S;
    var fade = smooth(clamp((p - .06) / .34));
    scene.style.transform = 'scale(' + S.toFixed(4) + ')';
    macro.style.clipPath = 'circle(' + rad.toFixed(1) + 'px at ' + G.x.toFixed(1) + 'px ' + G.y.toFixed(1) + 'px)';
    macro.style.opacity = fade.toFixed(3);
    macro.style.pointerEvents = fade > .5 ? 'auto' : '';
    enzV.style.transform = 'scale(' + (1.32 - .32 * zoom).toFixed(4) + ')';
    ring.style.width = ring.style.height = (rad * 2).toFixed(1) + 'px';
    ring.style.transform = 'translate(' + (G.x - rad).toFixed(1) + 'px,' + (G.y - rad).toFixed(1) + 'px)';
    ring.style.opacity = Math.min(fade, clamp(1 - (p - .58) / .12)).toFixed(3);
    heroCopy.style.transform = 'translateY(' + (-70 * copyOut).toFixed(1) + 'px)';
    heroCopy.style.opacity = (1 - copyOut).toFixed(3);
    heroCopy.inert = copyOut > .5;
    shade.style.opacity = (1 - copyOut).toFixed(3);
    cue.style.opacity = clamp(1 - p / .03).toFixed(3);
    cue.style.pointerEvents = p > .03 ? 'none' : '';
    var inCopy = out3(clamp((p - .7) / .2));
    enzCopy.style.transform = 'translateY(' + (48 * (1 - inCopy)).toFixed(1) + 'px)';
    enzCopy.style.opacity = inCopy.toFixed(3);
    enzCopy.inert = inCopy < .5;
    if (p > .01) load(enzV);
    want(heroV, diveOn && p < .72, 'dive');
    want(enzV, diveOn && fade > 0, 'dive');
  }
  setMode(); measure();
  heroV.addEventListener('canplaythrough', function () { setTimeout(function () { load(enzV); }, 1200); }, { once: true });
  if (tallQ.addEventListener) tallQ.addEventListener('change', function () { setMode(); measure(); onScroll(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); sizeScenes(); onScroll(); });

  /* Header: white over dark pictures (the film ends under the white wave), its wordmark once the big one has gone */
  var hdr = $('[data-hdr]'), darks = $$('[data-dark]');
  function paintHeader() {
    var y = 32, dark = false;
    // over the scenes that rise like water: the one that has risen whole (the next is under the header only once it
    // is whole too)
    if (SCN.cur) dark = SCN.cur.hasAttribute('data-dark');
    else darks.forEach(function (el) {
      if (SCN.on && el.classList.contains('scene')) return;
      // over the wave the film counts as dark only until the water reaches the header (white over the white foam
      // would not read), and never once the bottle's stage has taken over
      if (el === dive && FL.on && FL.s > -FL.W) { if (FL.s < 0 && FL.Y > 10) dark = true; return; }
      var b = el.getBoundingClientRect(), bottom = b.bottom - (el === dive ? 72 : 0); if (b.top <= y && bottom > y) dark = true;
    });
    hdr.classList.toggle('on-dark', dark);
    hdr.classList.toggle('wet', !dark && FL.on && FL.s > -FL.W && FL.s < 0);
    var r = dive.getBoundingClientRect();
    hdr.classList.toggle('glass', dark && !(r.top <= 1 && r.bottom >= innerHeight - 1));
    hdr.classList.toggle('brand-off', r.bottom > 0 && diveP < .12);
  }

  /* The buy bar: after the film, away at the shop and at the end (on phones also while a stage with its words at the
     foot holds the screen: the bottle and the dose) */
  var pill = $('[data-pill]'), shop = $('[data-shop]'), endSec = $('[data-end]');
  function paintPill() {
    var d = dive.getBoundingClientRect(), vh = innerHeight, phone = innerWidth < 960, on;
    // (with the rising water: once the bottle's scene is whole over the film)
    var after = FL.on ? FL.s >= 0 : d.bottom < vh * .35;
    if (SCN.on) {
      var away = function (s) { return !!s && (s === shop || s === endSec || (phone && s === doseSec)); };
      on = after && !(phone && !SCN.cur) && !away(SCN.cur) && !away(SCN.rising);
    } else {
      var s = shop.getBoundingClientRect(), e = endSec.getBoundingClientRect();
      var pinned = phone && pins.some(function (el) { var b = el.getBoundingClientRect(); return b.top <= hdr.offsetHeight + 1 && b.bottom >= vh - 1; });
      on = after && !pinned && !(s.top < vh * .9 && s.bottom > vh * .1) && e.top > vh * .8;
    }
    if (on !== pill.classList.contains('on')) { pill.classList.toggle('on', on); pill.inert = !on; root.classList.toggle('pill-on', on); }
  }

  /* Pinned stages: progress 0..1 while the section scrolls past its sticky stage */
  var pins = $$('[data-pin]');
  var brow = $('[data-brow]'), bottles = [];
  for (var i = 0; i < 10; i++) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 20 30');
    s.innerHTML = '<path d="M5 9c0-2 1-3 3-3l.5-2h3l.5 2c2 0 3 1 3 3v17c0 1.5-1 2.5-2.5 2.5h-5C6 28.5 5 27.5 5 26z" fill="currentColor" opacity=".9"/><rect x="7.5" y="1" width="5" height="3" rx="1" fill="currentColor"/>';
    brow.appendChild(s); bottles.push(s);
  }
  var bottleV = $('[data-bottle-video]'), bottleSec = $('[data-pin="bottle"]'), bottleA = 0, lastBvt = -1, midQ = matchMedia('(max-width: 959px) and (prefers-reduced-motion: no-preference)');
  // the words in white: a copy that lies on the dark ones, cut by the waterline in paintPins
  var bStick = bottleSec.querySelector('.pin__stick'), bStage = bottleSec.querySelector('.bstage'), bBox = bottleSec.querySelector('.bbox'), bSwirl = $('[data-bswirl]'), lastWsw = '', lastAv = '', lastBv = '', bVars = ['.bvidwrap', '.bfill', '.bstage'].map(function (s) { return bottleSec.querySelector(s); }), bDry = $('[data-bcopy]'), bWet = bDry.cloneNode(true), lastBvh = -1;
  bWet.classList.add('bcopy--wet'); bWet.removeAttribute('data-bcopy'); bWet.setAttribute('aria-hidden', 'true'); bWet.inert = true;
  bDry.parentNode.insertBefore(bWet, bDry.nextSibling);
  new IntersectionObserver(function (es) { if (es[0].isIntersecting) { load(bottleV); swirlLoad(); } }, { rootMargin: '120% 0px' }).observe(bottleSec);
  var lastB = -1, lastPh = -1;

  /* The swirl, piece by piece, like water: the pack's swirl as 111 pieces of one colour each (34 drops, every one the
     same master drop in its own size, length, bend and colours, and 77 bubbles, dots and glints; img/swirl3.json),
     drawn on a canvas over the whole stage by NeroSwirl12 (the script above). When the page stops at the box with the
     water up, each drop flies in head first along a lane of its own, from just out of sight (past the screen's edge or
     behind the box), in its exact shape all the way: it bends with its lane and its widths never change. It slows as
     it lands, sloshes a little and stays; a shade moves with its wave, the bubbles rise from below and where a drop
     lands the water ripples; all in about 3 seconds. At rest a slow current moves the waves while every small drop,
     bubble and dot bobs on its own; a mouse stirs the water as it passes, a tap ripples it, a scroll jolts it. At the
     count it goes out the way it came in: each drop leaves head first on along its lane, slow at first and faster as
     it goes, the bubbles rise on out at the top; and one drop (the blue one right of the box) flies at the screen:
     head first up over the box and on at the eye, seen nearer and nearer (its head grows much faster than its tail,
     which trails back towards the swirl), until its head covers the screen and its blue is the background. Scrolling
     back from the count, that drop pulls back from the screen and flies back to its place head first, smaller and
     smaller, and the swirl comes in again as at the start; scrolling up out of the scene, it leaves head first. Every piece moves head first whichever way the scroll turns. Its lanes are worked out
     while the page is idle, before it is seen; with reduced motion it just sits there, whole. */
  var bScene = bottleSec.querySelector('.bscene'), bGrow = document.createElement('div');
  bGrow.className = 'bgrow'; bScene.appendChild(bGrow);
  // t: the scene's own clock (seconds, while it is on screen), now: the slow motion at rest (it stops with the pause
  // button), wn: the water's own clock; g: where the swirl is on the stage (its units to px); out: past the count
  var SW = { state: 0, E: null, cv: null, ctx: null, g: null, key: '', still: '', on: false, out: false, bMax: 0, bLo: 0, grow: false, vis: false, live: false, dirty: false, raf: 0, ft: -1,
    t: 0, now: 0, wn: 0, ptr: null, y: null, prep: false };
  // the pieces come as a file where the page is served (the artifact); opened from the disk, where a page cannot
  // fetch, they come as a script (img/swirl3.js); if neither works the section simply has no swirl
  function swirlLoad() {
    if (SW.state) return;
    SW.state = 1;
    var viaScript = function () {
      var s = document.createElement('script');
      s.src = H.swirl3; s.async = true; s.onload = swirlBuild; s.onerror = function () { SW.state = -1; };
      document.head.appendChild(s);
    };
    viaScript(); return;
    fetch('img/swirl3.json').then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { window.NEROPOS_SWIRL3 = d; swirlBuild(); }, viaScript);
  }
  function swirlBuild() {
    var d = window.NEROPOS_SWIRL3; if (!d || !window.NeroSwirl12 || SW.state === 2) return;
    // the drop that comes at the screen: the blue one right of the box
    try { SW.E = window.NeroSwirl12(d, { bg: '#0b68cf' }); } catch (err) { SW.state = -1; return; }
    SW.cv = document.createElement('canvas'); SW.ctx = SW.cv.getContext('2d'); bSwirl.appendChild(SW.cv); SW.state = 2;
    // the background after the count is that drop's own colour
    if (SW.E.bg) bGrow.style.setProperty('--gc', SW.E.bg.q.fill);
    if (reduce) bSwirl.classList.add('still');
    paintPins();
    swirlPrep();
    // and the shop's swirl, from the same pieces
    shopBuild();
  }
  var idle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 600 }); } : function (f) { setTimeout(function () { f({ timeRemaining: function () { return 6; } }); }, 40); };
  // its lanes worked out while the page is idle, a piece at a time, so nothing stalls when it comes in; then the
  // browser draws it once out of sight, so its first frame on screen does not wait for that either
  function swirlPrep() {
    if (SW.state !== 2 || SW.prep || !SW.g || SW.on || reduce) return;
    var V = swirlView(), key = swirlKey(V), step = SW.E.planSteps(V);
    SW.prep = true;
    var run = function (dl) {
      if (SW.on || reduce || swirlKey(swirlView()) !== key) { SW.prep = false; return; }
      while (dl.timeRemaining() > 1) {
        if (step()) {
          SW.prep = false; SW.key = key;
          try { var c = document.createElement('canvas'); c.width = c.height = 512; var x = c.getContext('2d'); SW.E.warm(x, [.5, 0, 0]); x.getImageData(0, 0, 1, 1); } catch (err) { /* only a head start */ }
          return;
        }
      }
      idle(run);
    };
    idle(run);
  }
  // the screen in the swirl's units where it rests, the box at rest in the middle of it (each drop starts just out of
  // sight: past the screen's edge or behind the box), and the screen at the count, where the box and the swirl with it
  // are .7 of their size and 14% of the stage higher (the .bbox transform at --a 1, --b from .4)
  function swirlView() {
    var g = SW.g, bw = bBox.offsetWidth / 2 / g.rk, bh = bBox.offsetHeight / 2 / g.rk;
    var k = g.rk * .7, ox = g.rx + 512 * (g.rk - k), oy = g.ry + 512 * (g.rk - k) - .14 * bStage.offsetHeight;
    return { l: -g.rx / g.rk, r: (g.W - g.rx) / g.rk, t: -g.ry / g.rk, b: (g.H - g.ry) / g.rk, box: { l: 512 - bw, r: 512 + bw, t: 512 - bh, b: 512 + bh },
      far: { l: -ox / k, r: (g.W - ox) / k, t: -oy / k, b: (g.H - oy) / k } };
  }
  function swirlKey(V) { return [V.l, V.r, V.t, V.b, V.box.l, V.box.t].map(function (v) { return Math.round(v / 48); }).join(','); }
  // the screen now, in the swirl's units (it follows the box as it moves and shrinks)
  function swirlScr() { var g = SW.g; return { l: -g.ox / g.k, r: (g.W - g.ox) / g.k, t: -g.oy / g.k, b: (g.H - g.oy) / g.k }; }
  // the background after the count: shown once the drop covers the screen (the drop itself is on the canvas)
  function bgPaint() { var c = SW.E.covered(); if (c !== SW.grow) { bGrow.style.visibility = c ? 'visible' : 'hidden'; SW.grow = c; } }
  // what the scroll does to it: in when the page stops at the box with the water up (a .965 at that stop), out with
  // the drop at the count, back in as soon as the scroll heads back from the count (a tenth of the way back is enough;
  // a nudge the page settles back from is less) and out again only once it heads on past where it turned back; out
  // head first as soon as the water starts down; each scroll step jolts the water a little (a step down sends it
  // down, as if it lagged)
  function swirlPaint(a, b, vis) {
    if (SW.state !== 2) { if (vis) swirlLoad(); return; }
    var E = SW.E, V = swirlView(), key = swirlKey(V);
    SW.vis = vis;
    if (reduce) {
      // with reduced motion: at rest and whole, drawn again only when its place changes
      if (!SW.on) { SW.on = true; E.plan(V); SW.key = key; E.settle(); }
      var st = [SW.g.W, SW.g.H, SW.g.k.toFixed(5), SW.g.ox.toFixed(1), SW.g.oy.toFixed(1)].join();
      if (vis && st !== SW.still) { SW.still = st; E.frame({ t: 0, now: 0, dt: 0, scr: swirlScr() }); swirlDraw(); }
      return;
    }
    // its lanes for the screen now (worked out while the page was idle, unless the screen has changed since)
    if (key !== SW.key && (SW.on || a > .9)) { E.plan(V); SW.key = key; SW.dirty = true; }
    else if (key !== SW.key && !SW.prep) swirlPrep();
    if (!SW.on && a > .95) {
      // whoever jumps in past the count finds it whole (and deep past it, already blue)
      SW.on = true; SW.out = false; SW.bLo = 0; SW.dirty = true;
      if (b > .02) E.settle(); else E.enter(SW.t, false);
    } else if (SW.on && a < .9) { SW.on = false; SW.out = false; E.leave(SW.t, false); SW.dirty = true; }
    if (SW.on) {
      if (!SW.out) {
        if (b < SW.bLo) SW.bLo = b;
        if (b > SW.bLo + .04) { SW.out = true; SW.bMax = b; SW.dirty = true; if (b > .5 && !E.moving()) E.cover(); else E.leave(SW.t, true); }
      } else { if (b > SW.bMax) SW.bMax = b; if (b < .03 || b < SW.bMax - .1) { SW.out = false; SW.bLo = b; SW.dirty = true; E.enter(SW.t, b > .02); } }
    }
    var y = window.scrollY;
    if (SW.y !== null && y !== SW.y && SW.on) E.kick(clamp((y - SW.y) * .6, -60, 60));
    SW.y = y;
    swirlRun();
  }
  // its own frames run while something on it moves: a piece on its way, the slow motion at rest (unless paused), the
  // water, the pointer over it or the jolt; never off screen, before anything has come in, or under the drop's blue
  function swirlRun() {
    var E = SW.E, live = SW.state === 2 && !reduce && SW.vis && (E.moving() || (E.shown() && !E.covered() && (groups.bottle.on || SW.ptr || E.busy())));
    if (!live) SW.ft = -1;
    SW.live = live;
    if ((live || SW.dirty && SW.vis && SW.state === 2) && !SW.raf) SW.raf = requestAnimationFrame(swirlTick);
  }
  function swirlTick(ts) {
    SW.raf = 0;
    // when the page has scrolled, the scroll's paint comes next in this frame and draws the swirl after the box moved
    if ((SW.live || SW.dirty) && !ticking) swirlFrame(ts);
    swirlRun();
  }
  // one step of its clocks to the frame's time and the frame drawn (also when only its place on the stage changed)
  function swirlFrame(ts) {
    if (SW.state !== 2 || reduce || !SW.vis || !(SW.live || SW.dirty) || ts === SW.ft) return;
    var E = SW.E;
    if (!SW.on && !E.moving() && !E.shown()) { SW.dirty = false; return; }
    var dt = SW.ft < 0 || !SW.live ? 0 : Math.min(.1, (ts - SW.ft) / 1000);
    SW.ft = SW.live ? ts : -1; SW.dirty = false;
    SW.t += dt;
    if (groups.bottle.on) SW.now += dt;
    SW.wn += dt;
    E.waterStep(SW.ptr, SW.wn, dt);
    E.frame({ t: SW.t, now: SW.now, dt: dt, wnow: SW.wn, scr: swirlScr() });
    swirlDraw();
    bgPaint();
  }
  function swirlDraw() {
    var g = SW.g, cv = SW.cv, ctx = SW.ctx, dpr = Math.min(2, window.devicePixelRatio || 1), w = Math.round(g.W * dpr), h = Math.round(g.H * dpr);
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, h);
    SW.E.draw(ctx, [g.k * dpr, g.ox * dpr, g.oy * dpr]);
  }
  // the reader's hand in the water (in the swirl's units): a mouse or a pen stirs it as it passes, a tap ripples it
  function swirlAt(ev) { var g = SW.g, r = bStick.getBoundingClientRect(); return [(ev.clientX - r.left - g.ox) / g.k, (ev.clientY - r.top - g.oy) / g.k]; }
  if (!reduce) {
    bStick.addEventListener('pointermove', function (ev) { if (ev.pointerType === 'touch' || SW.state !== 2 || !SW.g) return; SW.ptr = swirlAt(ev); swirlRun(); });
    bStick.addEventListener('pointerleave', function () { SW.ptr = null; });
    bStick.addEventListener('pointerdown', function (ev) { if (SW.state !== 2 || !SW.g || !SW.on) return; var p = swirlAt(ev); SW.E.tap(p[0], p[1]); swirlRun(); });
  }
  // the pieces load while the page is idle, well before the scene
  idle(function () { swirlLoad(); });
  /* The bottle's scene rising over the cloth like water. s = 0 where the film's stage lets go: the bottle's scene is
     whole there. Its section starts W higher, so its stage is pinned in place from s = -W, where the film's last scene
     rests with the crest at its foot (the crest comes up in the film's last 110 px, as the page's edge did). Over W the
     waterline rises one to one with the scroll from the foot of the screen to the stage's top: the section is cut
     there (the cloth shows above it), the crest rides on the cut and the bottle drifts up a little with the water. */
  function riseSize() {
    if (FL.on) {
      FL.W = Math.max(240, stage.clientHeight - hdr.offsetHeight);
      dive.style.setProperty('--fr', FL.W + 'px');
      bottleSec.style.setProperty('--fd', FL.W + 'px');
    }
    // and the scenes after the bottle, which rise the same way over the same height
    sizeScenes();
  }
  function paintRise() {
    if (!FL.on) return;
    var vh = innerHeight, cH = FL.cH, W = FL.W, s = stage.clientHeight - dive.getBoundingClientRect().bottom;
    // stops are whole pixels: the bottle's can rest a fraction short of the water's end, which must not leave the crest up
    if (s < 0 && s > -1) s = 0;
    FL.s = s;
    // the film leaves the picture altogether once the bottle's scene is whole over it: the GPU can lift a paused film
    // left under it into a video overlay (on Windows a 300 ms stall)
    if ((s > 0) !== FL.sunk) { FL.sunk = s > 0; stage.style.visibility = FL.sunk ? 'hidden' : ''; }
    // the waterline on the screen (the crest's foot): under it until the crest comes up, at its foot while the film
    // rests, then up to the stage's top. The section is cut a pixel above it, under the crest's white, so that it is
    // first drawn while the film rests and not as the water starts to rise
    var w = s >= 0 ? 1 : s <= -W ? 0 : (s + W) / W, line = null, top = 0;
    if (s < 0 && s > -W - cH) { top = bStick.getBoundingClientRect().top; line = s <= -W ? vh - W - s : vh - w * (vh - top); }
    var cut = s >= 0 ? '' : line === null ? 'inset(100% 0 0 0)' : 'inset(' + Math.max(0, line - 1 - bottleSec.getBoundingClientRect().top).toFixed(1) + 'px 0 0 0)';
    if (cut !== FL.cut) { bottleSec.style.clipPath = cut; FL.cut = cut; }
    var wv = w.toFixed(3);
    if (wv !== FL.w) { bottleV.style.setProperty('--w', wv); FL.w = wv; }
    if (line === null || line - cH >= vh) { if (FL.shown) { riseEl.style.visibility = ''; FL.shown = false; } return; }
    if (!FL.shown) { riseEl.style.visibility = 'visible'; FL.shown = true; }
    // the foam thins out over the stage's top, so nothing is left to vanish as the crest goes
    var ff = clamp((line - top) / 90).toFixed(2);
    if (ff !== FL.ff) { riseFoot.style.opacity = ff; FL.ff = ff; }
    FL.Y = line - cH + 2;
    riseEl.style.transform = 'translate3d(0,' + FL.Y.toFixed(1) + 'px,0)';
  }
  function pinProgress(el, lead, tail) {
    lead = lead || 0; tail = tail || 0;
    var r = el.getBoundingClientRect(), run = el.offsetHeight - lead - tail - window.innerHeight;
    return run > 0 ? clamp((-r.top - lead) / run) : 0;
  }
  function paintPins() {
    pins.forEach(function (el) {
      var k = el.getAttribute('data-pin'), p = reduce ? 1 : pinProgress(el, k === 'bottle' ? FL.W : 0, k === 'bottle' && SCN.on ? R : 0);
      if (k === 'bottle') {
        var a = ease(clamp((p - .18) / .34)), b = clamp((p - .58) / .34), av = a.toFixed(3), bv = b.toFixed(3);
        // only on what reads them: set on the whole section, every scroll would restyle each path of the swirl
        if (av !== lastAv || bv !== lastBv) { bVars.forEach(function (v) { v.style.setProperty('--a', av); v.style.setProperty('--b', bv); }); lastAv = av; lastBv = bv; }
        // (on screen, and not yet under the first scene that rises over it)
        var br = el.getBoundingClientRect(), bOn = br.bottom > 0 && br.top < innerHeight && el._show !== false; bottleA = a;
        // with the wave its loop starts while the page rests at the cloth, so the film is already running (its first
        // frames decoded) when its section comes up under the water
        want(bottleV, br.bottom > 0 && br.top < innerHeight * (FL.on ? 1.4 : 1) && a < .98 && el._show !== false, 'bottle');
        var ph = p < .3 ? 0 : p < .6 ? 1 : 2;
        if (ph !== lastPh) { bDry.setAttribute('data-beat', ph); bWet.setAttribute('data-beat', ph); lastPh = ph; }
        // dark words above the water, white below it, and the box only under it (the crest's middle is 24 px over
        // the water's body); the cuts leave room for what overhangs a box, such as the tonos of «Έ» or a shadow
        var sr = bStick.getBoundingClientRect(), cr = bDry.getBoundingClientRect(), gr = bStage.getBoundingClientRect();
        var ws = sr.top + (1 - a) * (sr.height + 56) - 24;
        var wl = clamp(ws - cr.top, -60, cr.height + 60).toFixed(1), wg = clamp(ws - gr.top, -200, gr.height + 200).toFixed(1);
        bWet.style.clipPath = 'polygon(-60px ' + wl + 'px, calc(100% + 60px) ' + wl + 'px, calc(100% + 60px) calc(100% + 60px), -60px calc(100% + 60px))';
        bDry.style.clipPath = 'polygon(-60px -60px, calc(100% + 60px) -60px, calc(100% + 60px) ' + wl + 'px, -60px ' + wl + 'px)';
        bStage.style.clipPath = 'polygon(-200px ' + wg + 'px, calc(100% + 200px) ' + wg + 'px, calc(100% + 200px) calc(100% + 200px), -200px calc(100% + 200px))';
        // the swirl sits on the box's centre at 2.4 times the box's own height (never much wider than the screen) and
        // follows the box's place and scale; its canvas covers the stage (its pieces come from past the screen's edge
        // and fly off past it) and is cut at the waterline only
        var bx = bBox.getBoundingClientRect(), bh0 = bBox.offsetHeight || 1, ss = Math.min(bh0 * 2.4, sr.width * 1.1), k = ss * (bx.height / bh0) / 1024;
        var ox = bx.left + bx.width / 2 - sr.left - 512 * k, oy = bx.top + bx.height / 2 - sr.top - 512 * k, g0 = SW.g;
        if (!g0 || g0.W !== sr.width || g0.H !== sr.height || Math.abs(g0.k - k) > 1e-5 || Math.abs(g0.ox - ox) > .05 || Math.abs(g0.oy - oy) > .05) {
          // ... and where it rests once the water is up: on the box's own place, the middle of its stage
          var rk = ss / 1024;
          SW.g = { W: sr.width, H: sr.height, k: k, ox: ox, oy: oy, rk: rk, rx: gr.left + gr.width / 2 - sr.left - 512 * rk, ry: gr.top + gr.height / 2 - sr.top - 512 * rk };
          SW.dirty = true;
        }
        var wsw = clamp(ws - sr.top, 0, sr.height).toFixed(1);
        if (wsw !== lastWsw) { bSwirl.style.clipPath = 'inset(' + wsw + 'px 0 0 0)'; lastWsw = wsw; }
        var son = a > .5 && bOn;
        if (son !== bSwirl.classList.contains('on')) bSwirl.classList.toggle('on', son);
        swirlPaint(a, b, bOn);
        // on phones and tablets the loop is a band round the stage, over the title and the line (with reduced
        // motion, a band from the top down to the words)
        var mid = midQ.matches, bvt = mid ? Math.round(gr.top - sr.top - 28) : 0, bvh = mid ? Math.round(gr.height + 56) : Math.round(gr.bottom - sr.top + 36);
        if (bvh !== lastBvh || bvt !== lastBvt) { bStick.style.setProperty('--bvh', bvh + 'px'); bStick.style.setProperty('--bvt', bvt + 'px'); lastBvh = bvh; lastBvt = bvt; }
        // the bottles of a year go one by one (the number is in the title)
        var n = Math.round(clamp((b - .3) / .6) * 10);
        if (n !== lastB) { bottles.forEach(function (sv, j) { sv.classList.toggle('gone', j < n); }); lastB = n; }
      }
    });
  }

  /* The brand's drop (the swirl's master drop): its half width R sin(pi/2 s) along its spine from the tail's tip (s 0)
     to the head's centre (s 1), closed in front by a half circle of radius R. dropD: its outline round a spine of n
     points (tail first), as an SVG path */
  function dropD(X, Y, n, R) {
    var d = '', Rt = [], f = function (v) { return Math.round(v * 10) / 10; };
    for (var j = 0; j < n; j++) {
      var a = j ? j - 1 : 0, b = j < n - 1 ? j + 1 : n - 1, dx = X[b] - X[a], dy = Y[b] - Y[a], l = Math.hypot(dx, dy) || 1, w = R * Math.sin(Math.PI / 2 * j / (n - 1)), tx = dx / l, ty = dy / l;
      d += (j ? 'L' : 'M') + f(X[j] - ty * w) + ' ' + f(Y[j] + tx * w);
      Rt.push(f(X[j] + ty * w) + ' ' + f(Y[j] - tx * w));
    }
    d += 'A' + f(R) + ' ' + f(R) + ' 0 0 0 ' + Rt[n - 1];
    for (j = n - 2; j >= 1; j--) d += 'L' + Rt[j];
    return d + 'Z';
  }
  // a lane: a cubic Bezier a drop's head runs along, sampled by length; past its ends it carries on straight
  function laneOf(p0, p1, p2, p3) {
    var X = [], Y = [], S = [0];
    for (var i = 0; i <= 48; i++) {
      var t = i / 48, u = 1 - t, a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, e = t * t * t;
      X.push(a * p0[0] + b * p1[0] + c * p2[0] + e * p3[0]); Y.push(a * p0[1] + b * p1[1] + c * p2[1] + e * p3[1]);
      if (i) S.push(S[i - 1] + Math.hypot(X[i] - X[i - 1], Y[i] - Y[i - 1]));
    }
    return { X: X, Y: Y, S: S, n: 49, len: S[48] };
  }
  function laneAt(T, d, o, j) {
    var lo, hi, n = T.n;
    if (d <= 0) { lo = 0; hi = 1; } else if (d >= T.len) { lo = n - 2; hi = n - 1; }
    else { lo = 0; hi = n - 1; while (hi - lo > 1) { var m = (lo + hi) >> 1; if (T.S[m] <= d) lo = m; else hi = m; } }
    var f = (d - T.S[lo]) / ((T.S[hi] - T.S[lo]) || 1);
    o[j] = T.X[lo] + (T.X[hi] - T.X[lo]) * f; o[j + 1] = T.Y[lo] + (T.Y[hi] - T.Y[lo]) * f;
  }

  /* 4-9. The scenes after the bottle rise over one another like water, the way the bottle's scene rises over the
     cloth. A scene's box starts R and a screen higher than where it shows whole, its stage pinned under the header; w
     (0..1) is how far it has risen: 0 while the box's top is still under the header's foot, 1 once it is R above it.
     The box is cut at the waterline, which comes up with the scroll from a crest's height under the screen's foot (so
     the crest comes first) to the header, and one crest (.rise2) rides it in the coming scene's colours. The scene
     before holds still (its stage stays pinned); a scene is hidden while it has not started to rise and once the next
     has risen over it whole. */
  var scenes = $$('.home3 > .scene'), R = 0, SCN = { on: FL.on && scenes.length > 0, cur: null, rising: null, ff: '', y: undefined };
  var r2 = $('[data-rise2]'), r2Foot = r2 && r2.querySelector('.rise2__foot'), r2Bump = r2 && r2.querySelector('[data-r2bump]'), R2H = 110;
  // each scene's colours: its crest (front from the top down, back, the foam under it), the drop that brings it ([its
  // tail, its head]) and its way down (where it sets off and lands across the screen, and which way its lane bends)
  var LOOK = {
    care: { c: ['#BFE3FF', '#F2F9FF', '#FFFFFF'], b: '#8FCBFF', f: '#FFFFFF', d: ['#CFEBFF', '#FFFFFF'], x: [.66, .6], k: 1 },
    dose: { c: ['#3D7BFF', '#0C3A8C', '#04204E'], b: '#1F5BFF', f: 'rgba(4,32,78,0)', d: ['#3D7BFF', '#04204E'], x: [.3, .36], k: -1 },
    aegean: { c: ['#BFE3FF', '#E3F3FF', '#F2FAFF'], b: '#1FB4FD', f: '#F2FAFF', d: ['#9FE6FF', '#1FB4FD'], x: [.72, .66], k: 1 },
    shop: { c: ['#3D7BFF', '#0C3A8C', '#04204E'], b: '#1F5BFF', f: 'rgba(4,32,78,0)', d: ['#3D7BFF', '#04204E'], x: [.42, .48], k: -1 },
    faq: { c: ['#BFE3FF', '#DDEEFF', '#E6F3FF'], b: '#8FCBFF', f: '#E6F3FF', d: ['#FFFFFF', '#7FC2FF'], x: [.6, .54], k: 1 },
    end: { c: ['#3D7BFF', '#0C3A8C', '#04204E'], b: '#1F5BFF', f: 'rgba(4,32,78,0)', d: ['#3D7BFF', '#04204E'], x: [.36, .42], k: -1 }
  };
  function holdOf(sec) { return sec._hold || 0; }
  function sizeScenes() {
    if (SCN.on) {
      R = FL.W; root.style.setProperty('--R', R + 'px');
      // a scene with beats holds on its stage for most of a screen
      scenes.forEach(function (sec) { sec._hold = sec.hasAttribute('data-beats') ? Math.round(.9 * innerHeight) : 0; sec.style.setProperty('--hold', sec._hold + 'px'); });
    }
    fxSize(); doseMeasure();
    if (SH.E) { shopGeom(); SH.key = ''; }
  }
  function paintScenes() {
    if (!SCN.on) return;
    var hd = hdr.offsetHeight, vh = innerHeight, y = scrollY, dir = SCN.y === undefined ? 0 : y > SCN.y ? 1 : y < SCN.y ? -1 : 0, rising = null, line = 0, cur = null, i;
    SCN.y = y;
    for (i = 0; i < scenes.length; i++) {
      // (stops are whole pixels and a scene's top can be a fraction off one, its height being in vh: within a pixel and
      // a half of either end it is at that end)
      var sec = scenes[i], bt = sec.getBoundingClientRect().top, raw = (hd - bt) / R, w = raw <= 1.5 / R ? 0 : raw >= 1 - 1.5 / R ? 1 : raw, was = sec._w, cut;
      sec._w = w;
      // (whole: 'none', since the stylesheet hides a scene until this paints it)
      if (w <= 0) { cut = 'inset(100% 0 0 0)'; sec._line = vh + R2H; }
      else if (w >= 1) { cut = 'none'; cur = sec; sec._line = hd; }
      else {
        line = vh + R2H - w * (vh + R2H - hd); sec._line = line; rising = sec;
        cut = 'inset(' + Math.max(0, line - 1 - bt).toFixed(1) + 'px 0 0 0)';
      }
      if (cut !== sec._cut) { sec.style.clipPath = cut; sec._cut = cut; }
      // the drop that brings the scene, going on; going back, the one that leaps out of its water as it goes down
      // (none for a scene the page jumped right past)
      if (was !== undefined && FX.on && !FX.quiet) {
        if (was <= 0 && w > 0 && w < 1 && dir > 0) sceneDrop(sec, true);
        else if (was > .3 && w <= .3 && w > 0 && dir < 0) sceneDrop(sec, false);
      }
    }
    SCN.cur = cur;
    // what shows: a scene from when it starts to rise until the next has risen over it whole (the bottle until the
    // first has); a hidden one costs nothing to draw
    for (i = -1; i < scenes.length; i++) {
      var s = i < 0 ? bottleSec : scenes[i], nx = scenes[i + 1], show = (i < 0 || s._w > 0) && !(nx && nx._w >= 1);
      if (show !== s._show) { s._show = show; s.style.visibility = show ? '' : 'hidden'; }
    }
    // the crest on the waterline, in the colours of the scene that rises
    if (rising !== SCN.rising) {
      SCN.rising = rising;
      if (rising) { var L = LOOK[rising.id]; r2.style.setProperty('--r1', L.c[0]); r2.style.setProperty('--r2', L.c[1]); r2.style.setProperty('--r3', L.c[2]); r2.style.setProperty('--rb', L.b); r2.style.setProperty('--rf', L.f); }
      r2.style.visibility = rising ? 'visible' : '';
    }
    if (rising) {
      // the foam thins out over the header, so nothing is left to vanish as the crest goes
      var ff = clamp((line - hd) / 90).toFixed(2);
      if (ff !== SCN.ff) { r2Foot.style.opacity = ff; SCN.ff = ff; }
      r2.style.transform = 'translate3d(0,' + (line - R2H + 2).toFixed(1) + 'px,0)';
    }
  }

  /* The drops that bring the scenes, in a layer of their own over the page (under the header): each the brand's drop,
     flying head first along a lane of its own, in its exact shape all the way (it bends with its lane, its widths never
     change), and seen only above the water's surface when it has one */
  var NS = 'http://www.w3.org/2000/svg', FX = { on: SCN.on && !!$('[data-fx]'), svg: $('[data-fx]'), defs: null, list: [], bumps: [], raf: 0, quiet: false, id: 0, W: 0, H: 0 }, FP = [0, 0];
  function svgEl(tag, at, par) { var e = document.createElementNS(NS, tag); for (var k in at) e.setAttribute(k, at[k]); if (par) par.appendChild(e); return e; }
  function fxSize() { if (!FX.on) return; FX.W = innerWidth; FX.H = innerHeight; FX.svg.setAttribute('viewBox', '0 0 ' + FX.W + ' ' + FX.H); }
  // o: lane and h(t) (its head's place along the lane, t seconds after it set off), or ball (a small drop thrown up:
  // x y vx vy g); R, L (from the tail's tip to the head's centre); c [tail colour, head colour]; surf() the water's
  // surface on the screen; down: it goes into the water (gone once its tail is under it; hit(x, y) as its head gets
  // there), else it comes up out of the water and flies off over the top
  function fxDrop(o) {
    if (!FX.on) return;
    var k = ++FX.id, defs = FX.defs || (FX.defs = svgEl('defs', {}, FX.svg));
    o.cp = svgEl('clipPath', { id: 'fxc' + k, clipPathUnits: 'userSpaceOnUse' }, defs);
    o.cr = svgEl('rect', { x: -2000, y: -2000, width: 9999, height: 9999 }, o.cp);
    o.gr = svgEl('linearGradient', { id: 'fxg' + k, gradientUnits: 'userSpaceOnUse' }, defs);
    svgEl('stop', { offset: 0, 'stop-color': o.c[0] }, o.gr); svgEl('stop', { offset: 1, 'stop-color': o.c[1] }, o.gr);
    o.g = svgEl('g', { 'clip-path': 'url(#fxc' + k + ')' }, FX.svg);
    o.p = svgEl('path', { fill: 'url(#fxg' + k + ')' }, o.g);
    if (!o.ball) o.gl = svgEl('ellipse', { fill: '#fff', opacity: .5 }, o.g);
    o.n = o.ball ? 8 : 18; o.X = new Float64Array(o.n); o.Y = new Float64Array(o.n); o.t0 = performance.now(); o.hitDone = false;
    FX.list.push(o); fxRun();
  }
  function fxGone(o) { o.g.remove(); o.cp.remove(); o.gr.remove(); }
  // where a drop goes into the water: the water bulges up there (on the crest, as wide on a phone as it can be without
  // looking like a wall) and throws up two small drops, which fall back in head first
  function bump(x) {
    if (!r2Bump) return;
    var W = Math.max(1, FX.W), px = clamp(W * .16, 64, 120);
    FX.bumps = [{ t0: performance.now(), xv: x / W * 1440, sx: px * 1440 / W / 120 }]; fxRun();
  }
  function fxRun() { if (!FX.raf && (FX.list.length || FX.bumps.length)) FX.raf = requestAnimationFrame(fxStep); }
  function fxStep(now) {
    FX.raf = 0;
    for (var i = FX.list.length - 1; i >= 0; i--) {
      var o = FX.list[i], t = (now - o.t0) / 1000, s = o.surf ? o.surf() : null, gone = t > 3.5, j, n = o.n;
      if (o.ball) {
        var b = o.ball, vy = b.vy + b.g * t, sp = Math.hypot(b.vx, vy) || 1, px = b.x + b.vx * t, py = b.y + b.vy * t + .5 * b.g * t * t;
        for (j = 0; j < n; j++) { var f = o.L * (1 - j / (n - 1)); o.X[j] = px - b.vx / sp * f; o.Y[j] = py - vy / sp * f; }
        if (vy > 0 && s !== null && o.Y[0] > s + 1) gone = true;
      } else {
        var h = o.h(t);
        for (j = 0; j < n; j++) { laneAt(o.lane, h - o.L * (1 - j / (n - 1)), FP, 0); o.X[j] = FP[0]; o.Y[j] = FP[1]; }
      }
      var e = n - 1, hx = o.X[e], hy = o.Y[e], dx = hx - o.X[e - 2], dy = hy - o.Y[e - 2], dl = Math.hypot(dx, dy) || 1;
      o.p.setAttribute('d', dropD(o.X, o.Y, n, o.R));
      o.gr.setAttribute('x1', o.X[0].toFixed(1)); o.gr.setAttribute('y1', o.Y[0].toFixed(1));
      o.gr.setAttribute('x2', (hx + dx / dl * o.R).toFixed(1)); o.gr.setAttribute('y2', (hy + dy / dl * o.R).toFixed(1));
      if (o.gl) {
        // a glint on its head, up and to the left, where the light falls (as on the marks of the care scene)
        var gx = hx - .38 * o.R, gy = hy - .44 * o.R;
        o.gl.setAttribute('cx', gx.toFixed(1)); o.gl.setAttribute('cy', gy.toFixed(1)); o.gl.setAttribute('rx', (o.R * .3).toFixed(1)); o.gl.setAttribute('ry', (o.R * .19).toFixed(1));
        o.gl.setAttribute('transform', 'rotate(-50 ' + gx.toFixed(1) + ' ' + gy.toFixed(1) + ')');
      }
      if (s !== null) o.cr.setAttribute('height', Math.max(0, s + 2000).toFixed(1));
      if (o.down && !o.ball) {
        if (s !== null && !o.hitDone && hy + o.R >= s) { o.hitDone = true; if (o.hit) o.hit(hx, s); }
        if ((s !== null && o.Y[0] > s + 2) || o.Y[0] > FX.H + 40) gone = true;
      } else if (!o.down && hy < -o.R - 4 && o.Y[0] < -4) gone = true;
      if (gone) { fxGone(o); FX.list.splice(i, 1); }
    }
    // the crest's bulge: up and back, a smaller one after it, at rest (never below the level: it is water added on top)
    for (i = FX.bumps.length - 1; i >= 0; i--) {
      var bp = FX.bumps[i], tb = (now - bp.t0) / 1000, kk = tb < .26 ? Math.sin(Math.PI * tb / .26) : tb >= .4 && tb < .64 ? .3 * Math.sin(Math.PI * (tb - .4) / .24) : 0;
      r2Bump.setAttribute('transform', 'translate(' + bp.xv.toFixed(1) + ' 62) scale(' + bp.sx.toFixed(3) + ' ' + kk.toFixed(3) + ')');
      if (tb >= .64) FX.bumps.splice(i, 1);
    }
    fxRun();
  }
  // the drop that brings a scene: the brand's drop in the scene's colours, from over the top of the screen down onto the
  // crest as the water starts to rise, head first, bending on a lane of its own (each scene's differs); it goes into
  // the water and splashes. Going back, one leaps head first out of the water as it goes down and flies off over the top
  function sceneDrop(sec, down) {
    var L = LOOK[sec.id]; if (!L) return;
    var W = FX.W, H = FX.H, r = clamp(W / 72, 10, 20), len = r * 4.2, x0 = L.x[0] * W, x1 = L.x[1] * W, k = L.k;
    var surf = function () { return sec._line - 46; };
    if (down) {
      fxDrop({ lane: laneOf([x0, -len - r - 8], [x0 + k * .07 * W, .3 * H], [x1 - k * .05 * W, .62 * H], [x1, H + 260]), R: r, L: len, c: L.d, surf: surf, down: true,
        h: function (t) { return 760 * t + 1150 * t * t; },
        hit: function (x, y) {
          bump(x);
          [-1, 1].forEach(function (sg, j) {
            fxDrop({ ball: { x: x + sg * 5, y: y + 3, vx: sg * (120 + 70 * j), vy: -(390 + 60 * (1 - j)), g: 1700 }, R: r * .3, L: r * 1.1, c: L.d, surf: surf, down: true });
          });
        } });
    } else {
      var y0 = surf(), xa = x1 + k * .02 * W, xb = x0 - k * .05 * W;
      fxDrop({ lane: laneOf([xa, y0 + len + 2 * r], [xa - k * .03 * W, y0 - .3 * H], [xb, .2 * H], [xb + k * .04 * W, -400]), R: r, L: len, c: L.d, surf: surf, down: false,
        h: function (t) { return 2300 * t - 900 * t * t; } });
    }
  }

  /* 4. Care: once the scene has risen whole each mark's drop falls onto its place head first, one after another, and
     its sign and words come in as it lands; they go again once the scene has gone back under the water */
  var careSec = $('#care'), seals = $$('[data-seals] li'), careV = $('[data-care-video]'), CARE = { on: false };
  if (SCN.on && careSec) careSec.classList.add('wait');
  function paintCare() {
    if (!careSec) return;
    // its loop (the hand on the towels) is fetched while the bottle's water rises and plays while the scene shows
    if (SCN.on) {
      if (bottleA > .5 || careSec._w > 0) load(careV);
      want(careV, careSec._show !== false && careSec._w > .25, 'care');
    } else { var cr = careSec.getBoundingClientRect(); want(careV, cr.bottom > 0 && cr.top < innerHeight, 'care'); }
    if (!SCN.on) return;
    var w = careSec._w;
    if (!CARE.on && w >= .97) { CARE.on = true; sealsIn(); }
    else if (CARE.on && w <= 0) { CARE.on = false; sealsOut(); }
  }
  function sealsIn() {
    careSec.classList.remove('wait');
    seals.forEach(function (li, i) {
      var sv = li.querySelector('svg'), r = sv.getBoundingClientRect(), d = 220 + 170 * i, fall = Math.round(r.bottom + 40);
      li._an = [
        sv.animate([{ transform: 'translateY(' + (-fall) + 'px)', easing: 'cubic-bezier(.55,0,.85,.5)' }, { transform: 'translateY(5px)', offset: .74, easing: 'cubic-bezier(.3,.6,.4,1)' }, { transform: 'translateY(-3px)', offset: .87, easing: 'ease-in-out' }, { transform: 'none' }], { duration: 820, delay: d, fill: 'backwards' }),
        sv.querySelector('.seal__i').animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, delay: d + 640, fill: 'backwards' }),
        li.querySelector('span').animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: d + 660, fill: 'backwards', easing: 'cubic-bezier(.2,.8,.2,1)' })
      ];
    });
  }
  function sealsOut() { seals.forEach(function (li) { (li._an || []).forEach(function (a) { a.cancel(); }); li._an = null; }); careSec.classList.add('wait'); }

  /* 5. The dose: two beats on its pinned stage (p: 0 where it has risen whole, 1 at the second). At the first, the
     sheet tears a moment after the scene is whole (once a visit); on the way to the second the bowl's water rises over
     it in place, its crest on top, the words dark below the waterline; then the loop plays */
  var doseSec = $('#dose'), dStage = doseSec.querySelector('.scene__stage'), dFill = $('[data-dfill]'), dCrest = $('[data-dcrest]'), dSheet = $('[data-dsheet]'), doseV = $('[data-dose-video]'), dDry = $('[data-dcopy]'), dWet = dDry.cloneNode(true), DS = { beat: -1, cut: '', cr: '', wl: '', torn: false, tearT: 0 };
  dWet.classList.add('bcopy--wet'); dWet.removeAttribute('data-dcopy'); dWet.setAttribute('aria-hidden', 'true'); dWet.inert = true;
  dDry.parentNode.insertBefore(dWet, dDry.nextSibling);
  // the sheet lies on the bowl of the loop (its centre at BOWL, of 1920 x 1080, measured on its frames), as big as the
  // loop's own sheet, so the water rises over it where the loop's sheet then falls in; on phones the loop is a band
  // over the words, the bowl in its middle
  var BOWL = [1232, 540];
  function doseMeasure() {
    var W = dStage.clientWidth, H = dStage.clientHeight; if (!W || !H) return;
    var mid = innerWidth < 960, bx, by, bw, bh, px = .5;
    if (mid) {
      var sr = dStage.getBoundingClientRect(), st = doseSec.querySelector('.dstage').getBoundingClientRect(), band = Math.round(st.bottom - sr.top + 28);
      dStage.style.setProperty('--dvh', band + 'px'); bx = 0; by = 0; bw = W; bh = band;
      var s0 = Math.max(bw / 1920, bh / 1080); px = clamp((W / 2 - BOWL[0] * s0) / Math.min(-1, W - 1920 * s0));
      doseV.style.objectPosition = (px * 100).toFixed(1) + '% 50%';
    } else { bx = -.02 * W; by = -.02 * H; bw = 1.04 * W; bh = 1.04 * H; doseV.style.objectPosition = ''; }
    var s = Math.max(bw / 1920, bh / 1080), ox = bx + (bw - 1920 * s) * px, oy = by + (bh - 1080 * s) / 2;
    var cx = ox + BOWL[0] * s, cy = oy + BOWL[1] * s, size = Math.min(400 * s, .46 * (mid ? bh : H), .4 * W);
    dStage.style.setProperty('--sx', cx.toFixed(1) + 'px'); dStage.style.setProperty('--sy', cy.toFixed(1) + 'px'); dStage.style.setProperty('--ss', size.toFixed(1) + 'px');
  }
  function paintDose() {
    var p = 1, a = 1, shown = true;
    if (SCN.on) {
      var hd = hdr.offsetHeight, bt = doseSec.getBoundingClientRect().top, hold = holdOf(doseSec);
      p = hold > 0 ? clamp((hd - R - bt) / hold) : 0; a = ease(clamp((p - .12) / .66)); shown = doseSec._show !== false && doseSec._w > 0;
    }
    var beat = p < .5 ? 0 : 1;
    if (beat !== DS.beat) { dDry.setAttribute('data-beat', beat); dWet.setAttribute('data-beat', beat); DS.beat = beat; }
    // the waterline on the stage: from under its foot (the crest first) to over its top
    var sr = dStage.getBoundingClientRect(), Lw = (1 - a) * (sr.height + 50);
    var cut = a <= 0 ? 'inset(100% 0 0 0)' : 'inset(' + Math.max(0, Lw).toFixed(1) + 'px 0 0 0)';
    if (cut !== DS.cut) { dFill.style.clipPath = cut; DS.cut = cut; }
    var cr = a <= 0 || a >= 1 ? '' : (Lw - 47).toFixed(1);
    if (cr !== DS.cr) { if (!cr) dCrest.style.visibility = ''; else { dCrest.style.visibility = 'visible'; dCrest.style.transform = 'translate3d(0,' + cr + 'px,0)'; } DS.cr = cr; }
    // dark words under the water, white over it (a little over the water's body, at the crest's middle)
    var cb = dDry.getBoundingClientRect(), wl = clamp(sr.top + Lw - 20 - cb.top, -60, cb.height + 60).toFixed(1);
    if (wl !== DS.wl) {
      dWet.style.clipPath = 'polygon(-60px ' + wl + 'px, calc(100% + 60px) ' + wl + 'px, calc(100% + 60px) calc(100% + 60px), -60px calc(100% + 60px))';
      dDry.style.clipPath = 'polygon(-60px -60px, calc(100% + 60px) -60px, calc(100% + 60px) ' + wl + 'px, -60px ' + wl + 'px)';
      DS.wl = wl;
    }
    // the tear: a moment after the scene is whole; whole again once it has gone back under the water
    if (SCN.on) {
      if (doseSec._w >= 1 && !DS.torn && !DS.tearT) DS.tearT = setTimeout(function () { DS.tearT = 0; DS.torn = true; dSheet.classList.add('torn'); }, 900);
      else if (doseSec._w <= 0) { if (DS.tearT) { clearTimeout(DS.tearT); DS.tearT = 0; } if (DS.torn) { DS.torn = false; dSheet.classList.remove('torn'); } }
      if (careSec && careSec._w >= 1) load(doseV);
    }
    want(doseV, shown && a > .55, 'dose');
  }

  /* 6. Aegean Fresh: its loop plays while the scene shows. A tall screen (as for the film) gets its own 9:16 loop and
     poster, where the laundry hangs above the words; in the wide one it would sit under them */
  var aegSec = $('#aegean'), aegV = $('[data-aeg-video]'), aegM = '', asset = window.NEROPOS_ASSET || function (p) { return p; };
  var AEG = { wide: [aegV.getAttribute('data-src'), aegV.getAttribute('data-poster')], tall: [aegV.getAttribute('data-src-tall'), aegV.getAttribute('data-poster-tall')] };
  function aegMode() {
    var m = AEG.tall[0] && tallQ.matches ? 'tall' : 'wide', f = AEG[m];
    if (m === aegM) return;
    aegM = m; aegSec.classList.toggle('is-tall', m === 'tall');
    aegV.setAttribute('data-src', f[0]); aegV.poster = asset(f[1]);
    // already loaded: the other film in its place, which the next paint plays if the scene shows
    if (aegV.getAttribute('src')) aegV.src = asset(f[0]);
  }
  aegMode();
  if (tallQ.addEventListener) tallQ.addEventListener('change', function () { aegMode(); onScroll(); });
  function paintAeg() {
    var w = SCN.on ? aegSec._w : 1, shown = !SCN.on || aegSec._show !== false;
    if (SCN.on && (doseSec._w >= 1 || w > 0)) load(aegV);
    want(aegV, shown && w > .25, 'aeg');
  }

  /* 7. The shop: the pack's swirl once more, round the box, from the same pieces (a second NeroSwirl12): its drops fly
     in head first once the shop has risen whole, as at the bottle, and leave the same way when the shop goes */
  var shopSec = $('#shop'), sStage = shopSec.querySelector('.scene__stage'), sBox = shopSec.querySelector('.sbox'), sSwirl = $('[data-sswirl]');
  var SH = { E: null, cv: null, ctx: null, g: null, key: '', on: false, vis: false, live: false, raf: 0, ft: -1, t: 0, now: 0, wn: 0, ptr: null, prep: false, still: '' };
  function shopBuild() {
    var d = window.NEROPOS_SWIRL3; if (SH.E || !d || !window.NeroSwirl12) return;
    try { SH.E = window.NeroSwirl12(d, {}); } catch (err) { SH.E = null; return; }
    SH.cv = document.createElement('canvas'); SH.ctx = SH.cv.getContext('2d'); sSwirl.appendChild(SH.cv);
    if (reduce) sSwirl.classList.add('still');
    shopGeom(); shopPrep(); onScroll();
  }
  // where it sits: on the box's centre at 2.2 times the box's height (never much wider than the stage, and on a phone
  // never far over the words under the box), in the stage's px; the stage in the swirl's units with the box in the
  // middle of it
  var sPack = shopSec.querySelector('.spack');
  function shopGeom() {
    var sr = sStage.getBoundingClientRect(), bx = sBox.getBoundingClientRect(); if (!sr.width || !bx.height) return;
    var ss = Math.min(bx.height * 2.2, sr.width * 1.05, sPack.offsetHeight * 1.25), k = ss / 1024;
    SH.g = { W: sr.width, H: sr.height, k: k, ox: bx.left + bx.width / 2 - sr.left - 512 * k, oy: bx.top + bx.height / 2 - sr.top - 512 * k, bw: bx.width / 2 / k, bh: bx.height / 2 / k };
  }
  function shopScr() { var g = SH.g; return { l: -g.ox / g.k, r: (g.W - g.ox) / g.k, t: -g.oy / g.k, b: (g.H - g.oy) / g.k }; }
  function shopView() { var V = shopScr(), g = SH.g; V.box = { l: 512 - g.bw, r: 512 + g.bw, t: 512 - g.bh, b: 512 + g.bh }; V.far = shopScr(); return V; }
  function shopKey(V) { return [V.l, V.r, V.t, V.b, V.box.l, V.box.t].map(function (v) { return Math.round(v / 48); }).join(','); }
  // its lanes worked out while the page is idle, before it is seen
  function shopPrep() {
    if (!SH.E || !SH.g || SH.prep || SH.on || reduce) return;
    var V = shopView(), key = shopKey(V); if (key === SH.key) return;
    var step = SH.E.planSteps(V); SH.prep = true;
    var run = function (dl) {
      if (SH.on || !SH.g || shopKey(shopView()) !== key) { SH.prep = false; return; }
      while (dl.timeRemaining() > 1) if (step()) { SH.prep = false; SH.key = key; return; }
      idle(run);
    };
    idle(run);
  }
  function paintShop() {
    var w = SCN.on ? shopSec._w : 1;
    if (!SH.E) { if (!SCN.on || w > 0 || aegSec._w > 0) swirlLoad(); return; }
    if (!SH.g) shopGeom(); if (!SH.g) return;
    var fq = $('#faq'), nextW = SCN.on && fq ? fq._w || 0 : 0;
    SH.vis = (!SCN.on || shopSec._show !== false) && w > 0;
    var V = shopView(), key = shopKey(V);
    if (reduce) {
      if (!SH.on) { SH.on = true; SH.E.plan(V); SH.key = key; SH.E.settle(); }
      if (SH.vis && SH.still !== key) { SH.still = key; SH.E.frame({ t: 0, now: 0, dt: 0, scr: shopScr() }); shopDraw(); sSwirl.classList.add('on'); }
      return;
    }
    if (key !== SH.key && (SH.on || w > .9)) { SH.E.plan(V); SH.key = key; }
    else if (key !== SH.key && aegSec._w >= 1) shopPrep();
    var stay = w >= .98 && nextW <= 0;
    if (stay && !SH.on) { SH.on = true; SH.E.enter(SH.t, false); }
    else if (SH.on && (w < .9 || nextW > .02)) { SH.on = false; SH.E.leave(SH.t, false); }
    shopRun();
  }
  // its own frames run while something on it moves (a piece on its way, the slow motion at rest, the water, the
  // pointer), never while it is out of sight
  function shopRun() {
    var E = SH.E, live = !!E && !reduce && SH.vis && (E.moving() || E.shown() || !!SH.ptr || E.busy());
    if (!live) SH.ft = -1;
    SH.live = live;
    if (live && !SH.raf) SH.raf = requestAnimationFrame(shopTick);
  }
  function shopTick(ts) {
    SH.raf = 0; if (!SH.live) return;
    var dt = SH.ft < 0 ? 0 : Math.min(.1, (ts - SH.ft) / 1000); SH.ft = ts;
    SH.t += dt; SH.now += dt; SH.wn += dt;
    SH.E.waterStep(SH.ptr, SH.wn, dt);
    SH.E.frame({ t: SH.t, now: SH.now, dt: dt, wnow: SH.wn, scr: shopScr() });
    shopDraw();
    shopRun();
  }
  function shopDraw() {
    var g = SH.g, cv = SH.cv, ctx = SH.ctx, dpr = Math.min(2, window.devicePixelRatio || 1), w = Math.round(g.W * dpr), h = Math.round(g.H * dpr);
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, h);
    SH.E.draw(ctx, [g.k * dpr, g.ox * dpr, g.oy * dpr]);
  }
  // the reader's hand in the water: a mouse stirs it as it passes, a tap ripples it
  function shopAt(ev) { var r = sStage.getBoundingClientRect(); return [(ev.clientX - r.left - SH.g.ox) / SH.g.k, (ev.clientY - r.top - SH.g.oy) / SH.g.k]; }
  if (!reduce) {
    sStage.addEventListener('pointermove', function (ev) { if (ev.pointerType === 'touch' || !SH.E || !SH.g) return; SH.ptr = shopAt(ev); shopRun(); });
    sStage.addEventListener('pointerleave', function () { SH.ptr = null; });
    sStage.addEventListener('pointerdown', function (ev) { if (!SH.E || !SH.g || !SH.on) return; var p = shopAt(ev); SH.E.tap(p[0], p[1]); shopRun(); });
  }

  /* 9. The name fills with water drop by drop: once the last scene has risen whole, six of the brand's drops fall head
     first into its letters one after another, and the water comes up a step with each, sloshing a little; it empties
     again once the scene has gone back under the water (with reduced motion it is simply full) */
  var water = $('[data-water]'), mDrops = $('[data-mdrops]'), mClip = $('[data-mdclip]'), MX = [234, 521, 86, 603, 406, 375], MK = { on: false, n: 0, y: 150, v: 0, goal: 150, list: [], raf: 0, t: 0, next: 0 };
  function paintEnd() {
    if (!SCN.on) { water.setAttribute('transform', 'translate(0 4)'); return; }
    var w = endSec._w;
    if (!MK.on && w >= .97) { MK.on = true; MK.n = 0; MK.next = performance.now() + 260; endRun(); }
    else if (MK.on && w <= .3) { MK.on = false; MK.list.forEach(function (d) { d.p.remove(); }); MK.list = []; MK.goal = 150; endRun(); }
  }
  function endRun() { if (!MK.raf) MK.raf = requestAnimationFrame(endStep); }
  function endStep(now) {
    MK.raf = 0;
    var dt = MK.t ? Math.min(.05, (now - MK.t) / 1000) : 0; MK.t = now;
    if (MK.on && MK.n < MX.length && now >= MK.next) {
      var x = MX[MK.n], p = svgEl('path', { fill: 'url(#mdg)' }, mDrops);
      MK.list.push({ p: p, lane: laneOf([x + 9, -96], [x + 7, -40], [x + 2, 30], [x, 220]), t0: now, R: 7.5, L: 30, X: new Float64Array(12), Y: new Float64Array(12), hit: false });
      MK.n++; MK.next = now + 330;
    }
    // the water: a spring towards its level, a little past it and back
    MK.v += (-60 * (MK.y - MK.goal) - 9 * MK.v) * dt; MK.y += MK.v * dt;
    water.setAttribute('transform', 'translate(0 ' + MK.y.toFixed(2) + ')');
    var surf = MK.y + 10;
    mClip.setAttribute('height', Math.max(0, surf + 400).toFixed(1));
    for (var i = MK.list.length - 1; i >= 0; i--) {
      var d = MK.list[i], t = (now - d.t0) / 1000, h = 160 * t + 450 * t * t;
      for (var j = 0; j < 12; j++) { laneAt(d.lane, h - d.L * (1 - j / 11), FP, 0); d.X[j] = FP[0]; d.Y[j] = FP[1]; }
      d.p.setAttribute('d', dropD(d.X, d.Y, 12, d.R));
      if (!d.hit && d.Y[11] + d.R >= surf) { d.hit = true; MK.goal = Math.max(4, MK.goal - 146 / MX.length); }
      if (d.Y[0] > surf + 2 || t > 4) { d.p.remove(); MK.list.splice(i, 1); }
    }
    if (MK.list.length || (MK.on && MK.n < MX.length) || Math.abs(MK.v) > .4 || Math.abs(MK.y - MK.goal) > .25) endRun();
    else { MK.t = 0; MK.y = MK.goal; MK.v = 0; water.setAttribute('transform', 'translate(0 ' + MK.y.toFixed(2) + ')'); }
  }

  var ticking = false;
  function paint() { paintDive(); paintRise(); paintScenes(); paintHeader(); paintPill(); paintPins(); paintCare(); paintDose(); paintAeg(); paintShop(); paintEnd(); }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function (ts) { ticking = false; paint(); swirlFrame(ts); }); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    setMode(); measure(); riseSize();
    onScroll();
  });
  riseSize();
  paint();

  /* Scenes: one swipe moves the page one scene, never more. Stops are the film's two scenes, each beat of a pinned
     stage and every section's top; a section taller than the screen by a good part of it is read freely down to its
     end, and stops closer than 40% of the screen are one. A wheel or trackpad swipe glides at once to the next stop
     from where it started; the rest of that swipe (a trackpad's own inertia, more turns of the wheel) waits for the
     glide, a push that goes on after it moves one more, the other way turns back at once. Where the page moved by
     itself (a finger, a free section, the scrollbar), letting go carries it on to the next stop, or into the nearest
     once it has passed one. A touch or a key takes over at once; nothing glides with reduced motion. */
  var gliding = false, gRaf = 0, gDir = 0, gEnd = -1e9, restY = scrollY, prevY = scrollY, lastDir = 0, holding = false, tabT = -1e9, settleT = 0;
  // the wheel swipe in progress (WG), timed by when each event happened. A new swipe: a turn, or a pause (a wheel's
  // notch, 50 px or more after 30 ms of nothing, after QUIET; a trackpad after RESUME, since a busy page delivers the
  // rest of a swipe late and merged, which a short pause must not split). 'scene': the page takes it whole, one glide;
  // 'read': inside a long section the page moves the wheel's own distance and stops at the section's edge;
  // 'native': an event the page can no longer stop
  var QUIET = 180, RESUME = 700, PUSH = 24, NOTCH = 50, WG = { t: -1e9, dir: 0, mode: '', sum: 0, fired: false, hist: [], vmin: Infinity, f: null }, FT = { y: 0, raf: 0 };
  function stopsList() {
    var vh = innerHeight, top0 = hdr.offsetHeight, max = Math.round(document.documentElement.scrollHeight - vh), gap = .4 * vh;
    var docY = function (el) { return el.getBoundingClientRect().top + scrollY; };
    var list = [], free = [], slow = [], dTop = docY(dive), dEnd = dTop + dive.offsetHeight - stage.clientHeight - FL.W;
    list.push(dTop, dEnd); slow.push([dTop, dEnd, 3400]);
    // the water, from the cloth to the bottle: one scene, no stop on the way
    if (FL.on) slow.push([dEnd, dEnd + FL.W, 1800]);
    $$('.home3 > section').forEach(function (sec) {
      if (sec === dive) return;
      // a scene that rises like water: a stop where it has risen whole (the rise one slow glide), and one at the end
      // of its hold if it has one (its second beat)
      if (SCN.on && sec.classList.contains('scene')) {
        var st = docY(sec) - top0 + R, hold = holdOf(sec);
        list.push(st); slow.push([st - R, st, 1700]);
        if (hold) { list.push(st + hold); slow.push([st, st + hold, 1900]); }
        return;
      }
      // the bottle's section starts where its scene does, once the water is up, and the first scene rises over its tail
      var lead = sec === bottleSec ? FL.W : 0, tail = sec === bottleSec && SCN.on ? R : 0, top = docY(sec) + lead, h = sec.offsetHeight - lead - tail, beats = sec.getAttribute('data-beats'), end = top + h - vh;
      list.push(top - top0);
      if (beats) { beats.split(',').forEach(function (k) { list.push(top + (h - vh) * Number(k)); }); slow.push([top - top0, end, 1900]); return; }
      if (end - (top - top0) >= gap) { list.push(end); free.push([top - top0, end]); }
    });
    list.push(max);
    // stops closer than the gap are one: the earlier stays, only the page's end takes the place of the one before it
    var out = [];
    list.map(function (v) { return Math.round(clamp(v, 0, max)); }).sort(function (x, y) { return x - y; })
      .forEach(function (v) { var n = out.length; if (!n || v - out[n - 1] > gap) out.push(v); else if (v === max && n > 1) out[n - 1] = v; });
    // a free stretch starts and ends on stops
    free = free.map(function (f) {
      var a = out.filter(function (v) { return v <= f[0] + 2; }).pop(), z = out.filter(function (v) { return v >= f[1] - 2; })[0];
      return [a === undefined ? f[0] : a, z === undefined ? f[1] : z];
    });
    return { list: out, free: free, slow: slow };
  }
  function glide(to) {
    var from = scrollY, dist = to - from, lo = Math.min(from, to), hi = Math.max(from, to), t0 = performance.now();
    var S = stopsList(), L = S.list, dur = clamp(800 + Math.abs(dist) * .6, 1000, 2000);
    // a whole scene of the film or of a pinned stage runs its full time; a glide that starts part-way runs its share
    S.slow.forEach(function (r) {
      if (lo < r[0] - 2 || hi > r[1] + 2) return;
      var seg = dist > 0 ? to - (L.filter(function (v) { return v < to - 2; }).pop() || 0) : (L.filter(function (v) { return v > to + 2; })[0] || to) - to;
      dur = Math.max(900, r[2] * Math.min(1, Math.abs(dist) / Math.max(1, seg)));
    });
    var soft = function (t) { return (1 - Math.cos(Math.PI * t)) / 2; };
    gliding = true; gDir = dist > 0 ? 1 : -1; root.style.scrollBehavior = 'auto';
    // a long jump (a link across scenes) brings no drops on its way
    FX.quiet = Math.abs(dist) > 1.6 * R;
    (function step(now) {
      if (!gliding) return;
      var k = clamp((now - t0) / dur);
      window.scrollTo(0, from + dist * soft(k));
      if (k < 1) gRaf = requestAnimationFrame(step); else { gliding = false; FX.quiet = false; gEnd = performance.now(); root.style.scrollBehavior = ''; restY = prevY = to; }
    })(t0);
  }
  function halt() {
    if (FT.raf) { cancelAnimationFrame(FT.raf); FT.raf = 0; root.style.scrollBehavior = ''; }
    if (gliding) { gliding = false; FX.quiet = false; cancelAnimationFrame(gRaf); root.style.scrollBehavior = ''; restY = scrollY; }
  }
  // reading a long section by wheel: the page eases to where the wheel has taken it (a trackpad's deltas come every
  // frame and follow at once, a wheel's notch eases over a few frames), never past the section's edges
  function freeStep() {
    var y = Math.round(scrollY), d = FT.y - y;
    // there, or the page cannot go further (its height changed under it)
    if (!d || y === FT.prev) { FT.raf = 0; root.style.scrollBehavior = ''; return; }
    FT.prev = y;
    window.scrollTo(0, y + (d > 0 ? Math.ceil(d * .5) : Math.floor(d * .5)));
    FT.raf = requestAnimationFrame(freeStep);
  }
  function freeMove(dy, f) {
    if (!FT.raf) { FT.y = Math.round(scrollY); FT.prev = NaN; root.style.scrollBehavior = 'auto'; FT.raf = requestAnimationFrame(freeStep); }
    FT.y = Math.round(clamp(FT.y + dy, f[0], f[1]));
  }
  function nextStop(L, y, dir) { return dir > 0 ? L.filter(function (v) { return v > y + 2; })[0] : L.filter(function (v) { return v < y - 2; }).pop(); }
  function settle() {
    clearTimeout(settleT);
    if (gliding || holding || performance.now() - tabT < 900) return;
    if (performance.now() - WG.t < QUIET) { later(); return; }          // a wheel swipe is still coming in
    var y = scrollY, S = stopsList(), L = S.list, near = function (v) { return Math.abs(v - y) <= 2; };
    if (L.some(near) || S.free.some(function (f) { return y > f[0] + 2 && y < f[1] - 2; })) { restY = y; return; }
    var to, lo = Math.min(restY, y), hi = Math.max(restY, y), wasStop = L.some(function (v) { return Math.abs(v - restY) <= 2; });
    if (wasStop && Math.abs(y - restY) < 28) to = restY;                // only a nudge: back where it was
    else if (L.some(function (v) { return v > lo + 2 && v < hi - 2; }))  // it went past a stop by itself: into the nearest
      to = L.reduce(function (a, v) { return Math.abs(v - y) < Math.abs(a - y) ? v : a; });
    else to = nextStop(L, y, lastDir >= 0 ? 1 : -1);
    if (to === undefined) { restY = y; return; }
    glide(to);
  }
  function later() { clearTimeout(settleT); settleT = setTimeout(settle, 120); }
  // pushed again, not a trackpad's inertia fading away: the wheel's speed over its last few events (distance over
  // time, so uneven timing and events a busy page merged count right) is well above the slowest it has been since
  // (a fading inertia only ever slows; a new push, after the fingers stop it, starts from nothing and rises fast)
  function pushing() {
    var h = WG.hist, n = h.length;
    if (n < 5) return false;
    for (var s = 0, k = n - 4; k < n; k++) s += h[k][1];
    var v = s / Math.max(8, h[n - 1][0] - h[n - 5][0]);
    WG.vmin = Math.min(WG.vmin, v);
    return v >= .3 && v >= 2 * WG.vmin + .1;
  }
  function fire(dir) {
    halt();
    var to = nextStop(stopsList().list, scrollY, dir);
    WG.fired = true; WG.hist = []; WG.vmin = Infinity;
    if (to !== undefined) { lastDir = dir; glide(to); }
  }
  function onWheel(e) {
    if (e.ctrlKey) return;                                              // a pinch on the trackpad zooms the page
    if (document.querySelector('dialog[open]')) return;                // an open drawer scrolls as usual
    var dy = e.deltaY * (e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? innerHeight : 1);
    if (Math.abs(e.deltaX) > Math.abs(dy)) return;                      // sideways
    var now = e.timeStamp || performance.now(), dir = dy > 0 ? 1 : dy < 0 ? -1 : 0, a = Math.abs(dy), gap = now - WG.t, notch = a >= NOTCH && gap >= 30;
    if (!dir) { if (gap <= QUIET && WG.mode !== 'native' && e.cancelable) e.preventDefault(); return; }
    if (dir !== WG.dir || gap > (notch ? QUIET : RESUME)) {
      WG.dir = dir; WG.sum = 0; WG.fired = false; WG.hist = []; WG.vmin = Infinity; WG.f = null;
      // during a glide the same way waits for it, the other way turns it back (once pushed far enough to mean it)
      if (gliding) { WG.mode = 'scene'; WG.fired = dir === gDir; }
      else {
        var y = scrollY;
        WG.f = stopsList().free.filter(function (f) { return dir > 0 ? y >= f[0] - 2 && y < f[1] - 2 : y > f[0] + 2 && y <= f[1] + 2; })[0] || null;
        WG.mode = WG.f ? 'read' : 'scene';
      }
    }
    WG.t = now;
    if (WG.mode === 'native' || !e.cancelable) { WG.mode = 'native'; if (gliding) halt(); return; }
    e.preventDefault();
    WG.hist.push([now, a]); if (WG.hist.length > 16) WG.hist.shift();
    if (WG.mode === 'read') {
      if (Math.abs((FT.raf ? FT.y : Math.round(scrollY)) - (dir > 0 ? WG.f[1] : WG.f[0])) > 1) { freeMove(dy, WG.f); return; }
      // at the section's edge the rest of this swipe stops; a push that goes on moves on to the next scene
      WG.mode = 'scene'; WG.fired = true; WG.hist = []; WG.vmin = Infinity;
      return;
    }
    if (!WG.fired) { WG.sum += a; if (WG.sum >= PUSH) fire(dir); }
    else if (!gliding && now - gEnd > 120 && (notch || pushing())) fire(dir);
  }
  if (!reduce) {
    window.addEventListener('scroll', function () {
      var y = scrollY;
      if (!gliding) { if (y !== prevY) lastDir = y > prevY ? 1 : -1; later(); }
      prevY = y;
    }, { passive: true });
    if ('onscrollend' in window) window.addEventListener('scrollend', function () { if (!gliding) settle(); });
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', function () { holding = true; halt(); }, { passive: true });
    window.addEventListener('touchend', function () { holding = false; later(); }, { passive: true });
    window.addEventListener('touchcancel', function () { holding = false; later(); }, { passive: true });
    window.addEventListener('mousedown', function (e) { if (e.button === 0) holding = true; halt(); });
    // letting go of the mouse (a dragged scrollbar, a glide stopped by a press) settles the page as a finger's does,
    // and where it rests is where the next movement starts from
    window.addEventListener('mouseup', function () { if (holding) { holding = false; later(); } });
    cue.addEventListener('click', function (e) {
      var to = stopsList().list.filter(function (v) { return v > scrollY + 2; })[0];
      if (to === undefined) return;
      e.preventDefault(); lastDir = 1; glide(to);
    });
    // a link to a place on the page glides there, to the same spot the browser would scroll to
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var id = a.getAttribute('href').slice(1), el = id && document.getElementById(id);
      if (!el) return;
      var max = root.scrollHeight - innerHeight, pad = parseFloat(getComputedStyle(root).scrollPaddingTop) || 0;
      var to = Math.round(clamp(el.getBoundingClientRect().top + scrollY - (parseFloat(getComputedStyle(el).scrollMarginTop) || 0) - pad, 0, max));
      e.preventDefault(); lastDir = to > scrollY ? 1 : -1; glide(to);
      // from the keyboard, focus goes where the link points, as it would without the glide
      if (e.detail === 0) { if (!el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '-1'); el.setAttribute('data-navto', ''); } el.focus({ preventScroll: true }); }
    });
    window.addEventListener('keydown', function (e) {
      if (document.querySelector('dialog[open]')) return;
      if (e.key === 'Tab') tabT = performance.now();
      halt();
      // paging keys step one scene at a time; inside a long section they scroll as usual
      var k = e.key, down = k === 'PageDown' || k === 'ArrowDown' || (k === ' ' && !e.shiftKey), up = k === 'PageUp' || k === 'ArrowUp' || (k === ' ' && e.shiftKey);
      if (!(down || up) || e.altKey || e.ctrlKey || e.metaKey || e.defaultPrevented) return;
      if (k === ' ' && e.target && e.target.closest && e.target.closest('a,button,summary,input,textarea,select,[contenteditable]')) return;
      var y = scrollY, S = stopsList(), L = S.list;
      var to = down ? L.filter(function (v) { return v > y + 2; })[0] : L.filter(function (v) { return v < y - 2; }).pop();
      if (to === undefined) return;
      var lo = Math.min(y, to), hi = Math.max(y, to);
      if (S.free.some(function (f) { return lo >= f[0] - 2 && hi <= f[1] + 2; })) return;
      e.preventDefault(); lastDir = down ? 1 : -1; glide(to);
    });
  }

  // the dose's sheet has a soft shadow (a drop-shadow), a blur the browser builds the first time it draws one: drawn
  // once, all but invisible, while the page is idle at the start, it does not stall the scroll when the dose comes up
  idle(function () {
    var w = document.createElement('div');
    w.setAttribute('aria-hidden', 'true');
    w.style.cssText = 'position:fixed;left:0;top:0;width:12px;height:12px;opacity:.01;pointer-events:none;background:#fff;filter:' + getComputedStyle(dSheet).filter;
    document.body.appendChild(w);
    setTimeout(function () { w.remove(); }, 400);
  });

  /* 7. The quantity: its total on the button and how long it lasts (each row carries its price, from Liquid) */
  var buyN = Number(H.n) || 2, lastsEl = $('[data-lasts]');
  function sumOf(n) { var b = $('.qty [data-q="' + n + '"]'); return b ? Number(b.getAttribute('data-sum')) : 0; }
  function paintQty() {
    $$('.qty [data-q]').forEach(function (x) { x.setAttribute('aria-checked', String(Number(x.getAttribute('data-q')) === buyN)); });
    var t = $('[data-buytotal]'); if (t) t.textContent = money(sumOf(buyN));
    if (lastsEl && NPx.tx && NPx.lasts) lastsEl.innerHTML = NPx.tx(buyN === 1 ? 'lasts_one_html' : 'lasts_other_html', { time: NPx.lasts((Number(H.washes) || 30) * buyN, 4) });
  }
  $$('.qty [data-q]').forEach(function (b) { b.addEventListener('click', function () { buyN = Number(b.getAttribute('data-q')); paintQty(); }); });
  paintQty();

  /* Add to cart: the shop's button takes the quantity, the bar one box */
  $$('[data-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-add');
      if (k === 'buy') add(H.main || 'aegean', buyN, b); else add(k, 1, b);
    });
  });

  // for the page's checks
  window.__neroStops = function () { return stopsList(); };
})();
